import { useEffect, useRef, useState } from 'react';

interface UseCountdownOptions {
  seconds: number;
  onEnd?: () => void;
}

export const useCountdown = ({ seconds, onEnd }: UseCountdownOptions): number => {
  const [count, setCount] = useState(seconds);
  const stableOnEnd = useRef(onEnd);
  const hasEnded = useRef(false);

  useEffect(() => {
    setCount(seconds);
    hasEnded.current = false;

    const interval = window.setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          if (!hasEnded.current) {
            hasEnded.current = true;
            stableOnEnd.current?.();
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  return count;
};
